/**
 * Login Page - Redesigned Sign In
 * Stitch: Smart Home App - Mobile, Screen "Redesigned Sign In"
 * Project ID: 3749155811323131250, Screen ID: 4bf881482ecb4d0d842d83084786965b
 */
import './LoginPageRedesignedSignIn.css'

/** Google "G" logo - official brand colors */
function GoogleIcon({ className }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" width={30} height={30} aria-hidden>
      <path
        fill="#4285F4"
        d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"
      />
      <path
        fill="#34A853"
        d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"
      />
      <path
        fill="#FBBC05"
        d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"
      />
      <path
        fill="#EA4335"
        d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"
      />
    </svg>
  )
}

/** Apple logo - black for white button，viewBox 留足邊距避免裁切 */
function AppleIcon({ className }: { className?: string }) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      width={30}
      height={30}
      aria-hidden
      fill="#000"
      preserveAspectRatio="xMidYMid meet"
      style={{ overflow: 'visible', minWidth: 30 }}
    >
      <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 9.05 7.31c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.54 4.09l.01-.01zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
    </svg>
  )
}

export interface LoginPageRedesignedSignInProps {
  /** AppFactory preview: 點擊登入按鈕時觸發（從 user profile 取得 credential） */
  onLogin?: () => void
  /** App Suite client branding: optional custom logo image URL */
  logoImageUrl?: string
}

export default function LoginPageRedesignedSignIn({
  onLogin,
  logoImageUrl,
}: LoginPageRedesignedSignInProps = {}) {
  const handleClick = () => onLogin?.()
  return (
    <div className="login-page-redesigned-sign-in">
      <div className="login-page-redesigned-header">
        {logoImageUrl ? (
          <img src={logoImageUrl} alt="App Logo" className="login-page-redesigned-logo-image" />
        ) : (
          <span className="material-symbols-rounded login-page-redesigned-icon">home_iot_device</span>
        )}
        <h1 className="login-page-redesigned-title">Welcome Home</h1>
        <p className="login-page-redesigned-subtitle">Control your home seamlessly.</p>
      </div>
      <div className="login-page-redesigned-actions">
        <button type="button" className="login-page-redesigned-btn login-page-redesigned-btn-google" onClick={handleClick}>
          <GoogleIcon className="login-page-redesigned-btn-icon" />
          Sign in with Google
        </button>
        <button type="button" className="login-page-redesigned-btn login-page-redesigned-btn-apple" onClick={handleClick}>
          <AppleIcon className="login-page-redesigned-btn-icon" />
          Sign in with Apple
        </button>
      </div>
    </div>
  )
}
